"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
const editableCampaign_1 = require("../reducers/editableCampaign");
const util_1 = require("./util");
exports.publishCampaign = (id) => (dispatch) => {
    const query = graphql_tag_1.default `
            mutation CampaignPublish($id: ID!) {
                campaignPublish(id: $id)
            }
        `;
    const request = {
        query,
        variables: {
            id,
        },
    };
    dispatch({ type: 'PUBLISH_CAMPAIGN_REQUEST' });
    return Environment_1.default(request).then(({ errors }) => {
        if (errors) {
            return handleError_1.default('PUBLISH_CAMPAIGN_FAILURE', dispatch, errors[0].message);
        }
        else {
            return dispatch({
                type: 'PUBLISH_CAMPAIGN_SUCCESS',
            });
        }
    }, ({ result }) => handleError_1.default('PUBLISH_CAMPAIGN_FAILURE', dispatch, result.errors[0].message));
};
exports.updateTrigger = () => (dispatch, getState) => {
    const query = graphql_tag_1.default `
    mutation CampaignUpdateTrigger(
        $id: ID!
        $trigger: CampaignTriggerInput!
    ) {
        campaignUpdateTrigger(
            id: $id
            trigger: $trigger
        ) {
            ${nodeQuery}
        }
    }`;
    const state = getState();
    const { id, trigger } = editableCampaign_1.getEditableCampaign(state);
    let triggerInput = {};
    switch (trigger.__typename) {
        case 'CampaignAPITrigger':
            triggerInput = {
                apiTrigger: {
                    fields: trigger.fields,
                    segment: segmentToOutput(trigger.segment),
                },
            };
            break;
        case 'CampaignAutomatedTrigger':
            const filters = automatedFiltersToOutput(trigger.eventTrigger.filters);
            const automatedTrigger = Object.assign(Object.assign({}, trigger), { segment: segmentToOutput(trigger.segment), eventTrigger: Object.assign(Object.assign({}, trigger.eventTrigger), { filters }) });
            const { __typename: automatedTypename } = automatedTrigger, restAutomatedTrigger = __rest(automatedTrigger, ["__typename"]);
            triggerInput = { automatedTrigger: restAutomatedTrigger };
            break;
        case 'CampaignScheduledTrigger':
            const scheduledTrigger = Object.assign(Object.assign({}, trigger), { segment: segmentToOutput(trigger.segment) });
            const { __typename: scheduledTypename } = scheduledTrigger, restScheduledTrigger = __rest(scheduledTrigger, ["__typename"]);
            triggerInput = { scheduledTrigger: restScheduledTrigger };
            break;
        default:
            break;
    }
    const request = {
        query,
        variables: {
            id,
            trigger: triggerInput,
        },
    };
    dispatch({ type: 'UPDATE_TRIGGER_REQUEST' });
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            handleError_1.default('UPDATE_TRIGGER_ERROR', dispatch, errors[0].message);
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [data.campaignUpdateTrigger.id]: Object.assign({}, data.campaignUpdateTrigger) });
            dispatch(updateCampaignUIState());
            dispatch({
                type: 'UPDATE_TRIGGER_SUCCESS',
                campaigns,
            });
        }
    }, ({ result }) => handleError_1.default('UPDATE_TRIGGER_FAILURE', dispatch, result.errors[0].message));
};
exports.updateDeliverable = () => (dispatch, getState) => {
    const query = graphql_tag_1.default `
        mutation CampaignUpdateNotificationDeliverable(
            $id:ID!,
            $alertOptions: CampaignNotificationDeliverableAlertOptionsInput!,
            $androidOptions: CampaignNotificationDeliverableAndroidOptionsInput,
            $attachment: CampaignNotificationDeliverableAttachmentInput,
            $body: String!,
            $iOSOptions: CampaignNotificationDeliverableIOSNotificationOptionsInput,
            $tapBehavior: CampaignNotificationDeliverableTapBehaviorInput!,
            $title: String
        ){
            campaignUpdateNotificationDeliverable(
                id: $id,
                alertOptions: $alertOptions,
                androidOptions: $androidOptions,
                attachment: $attachment,
                body: $body,
                iOSOptions: $iOSOptions,
                tapBehavior: $tapBehavior,
                title: $title
            ){
                ${nodeQuery}
            }
        }
    `;
    const state = getState();
    const { editableCampaign } = state;
    const _a = editableCampaign.deliverable, { __typename } = _a, restDeliverable = __rest(_a, ["__typename"]);
    const request = {
        query,
        variables: Object.assign({ id: editableCampaign.id }, restDeliverable),
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('UPDATE_CAMPAIGN_DELIVERABLE_FAILURE', dispatch, errors[0].message);
        }
        else {
            dispatch(updateCampaignUIState()).then(() => {
                const campaign = data.campaignUpdateNotificationDeliverable;
                const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [campaign.id]: Object.assign({}, campaign) });
                return dispatch({
                    type: 'UPDATE_CAMPAIGN_DELIVERABLE_SUCCESS',
                    campaigns,
                });
            });
        }
    }, ({ result }) => handleError_1.default('UPDATE_CAMPAIGN_DELIVERABLE_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchCampaign = (id) => (dispatch, getState) => {
    dispatch({ type: 'FETCH_CAMPAIGN_REQUEST' });
    const query = graphql_tag_1.default `
        query FetchCampaign($id: ID!) {
            campaign(id: $id) {
                ${nodeQuery}
            }
        }
    `;
    const request = {
        query,
        variables: {
            id,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        return new Promise((resolve, reject) => {
            if (errors) {
                handleError_1.default('FETCH_CAMPAIGN_FAILURE', dispatch, errors[0].message);
            }
            else {
                const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [data.campaign.id]: Object.assign({}, data.campaign) });
                dispatch({
                    type: 'FETCH_CAMPAIGN_SUCCESS',
                    campaigns,
                });
                resolve();
            }
        });
    }, ({ result }) => handleError_1.default('FETCH_CAMPAIGN_FAILURE', dispatch, result.errors[0].message));
};
exports.duplicateListViewCampaign = (name, id) => (dispatch, getState) => {
    const query = graphql_tag_1.default `
        mutation CampaignDuplicate($name: String!, $id: ID!) {
            campaignDuplicate(name: $name, id: $id) {
                ${nodeQuery}
            }
        }
    `;
    const request = {
        query,
        variables: {
            name,
            id,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('DUPLICATE_CAMPAIGN_FAILURE', dispatch, errors[0].message);
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [data.campaignDuplicate.id]: Object.assign({}, data.campaignDuplicate) });
            return dispatch({
                type: 'DUPLICATE_CAMPAIGN_SUCCESS',
                campaigns,
            });
        }
    }, ({ result }) => handleError_1.default('DUPLICATE_CAMPAIGN_FAILURE', dispatch, result.errors[0].message));
};
exports.duplicateCampaign = (name, id) => (dispatch, getState) => {
    const query = graphql_tag_1.default `
        mutation CampaignDuplicate($name: String!, $id: ID!) {
            campaignDuplicate(name: $name, id: $id) {
                ${nodeQuery}
            }
        }
    `;
    const request = {
        query,
        variables: {
            name,
            id,
        },
    };
    dispatch({
        type: 'TRIGGERED_ANIMATION',
        trigger: 'duplicate',
    });
    dispatch({
        type: 'CLOSING_OVERVIEW_MODAL',
    });
    let closed = false;
    setTimeout(() => {
        dispatch({
            type: 'CLOSED_OVERVIEW_MODAL',
        });
        closed = true;
    }, 350);
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            dispatch({
                type: 'DUPLICATE_CAMPAIGN_FAILURE',
                message: errors[0].message,
            });
            return new Promise((resolve) => {
                setTimeout(() => {
                    dispatch({
                        type: 'OPEN_OVERVIEW_MODAL',
                    });
                    return resolve();
                }, !closed ? 350 : 0);
                setTimeout(() => {
                    dispatch({ type: 'DISMISS_FAILURE' });
                }, 4000);
            }).then((res) => Promise.resolve(id));
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [data.campaignDuplicate.id]: Object.assign({}, data.campaignDuplicate) });
            return new Promise((resolve) => {
                setTimeout(() => {
                    dispatch({
                        type: 'OPEN_OVERVIEW_MODAL',
                    });
                    return resolve();
                }, !closed ? 350 : 0);
            }).then((result) => {
                dispatch({
                    type: 'DUPLICATE_CAMPAIGN_SUCCESS',
                    campaigns,
                });
                return Promise.resolve(data.campaignDuplicate.id);
            });
        }
    }, ({ result }) => {
        dispatch({
            type: 'DUPLICATE_CAMPAIGN_FAILURE',
            message: result.errors[0].message,
        });
        return new Promise((resolve) => {
            setTimeout(() => {
                dispatch({
                    type: 'OPEN_OVERVIEW_MODAL',
                });
                return resolve();
            }, !closed ? 350 : 0);
            setTimeout(() => {
                dispatch({ type: 'DISMISS_FAILURE' });
            }, 4000);
        }).then((res) => Promise.resolve(id));
    });
};
exports.archiveCampaign = (id) => (dispatch, getState) => {
    const query = graphql_tag_1.default `
            mutation CampaignArchive($id: ID!) {
                campaignArchive(id: $id)
            }
        `;
    const request = {
        query,
        variables: {
            id,
        },
    };
    dispatch({
        type: 'TRIGGERED_ANIMATION',
        trigger: '',
    });
    dispatch({
        type: 'CLOSING_OVERVIEW_MODAL',
    });
    let closed = false;
    setTimeout(() => {
        dispatch({
            type: 'CLOSED_OVERVIEW_MODAL',
        });
        closed = true;
    }, 350);
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            dispatch({
                type: 'ARCHIVE_CAMPAIGN_FAILURE',
                message: errors[0].message,
            });
            return new Promise((resolve) => {
                setTimeout(() => {
                    dispatch({
                        type: 'OPEN_OVERVIEW_MODAL',
                    });
                }, !closed ? 300 : 0);
                setTimeout(() => {
                    dispatch({ type: 'DISMISS_FAILURE' });
                    return resolve();
                }, 4000);
            }).then((res) => Promise.resolve(false));
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [id]: Object.assign(Object.assign({}, getState().campaignConnection.campaigns[id]), { status: 'ARCHIVED' }) });
            return new Promise((resolve) => {
                setTimeout(() => {
                    dispatch({
                        type: 'ARCHIVE_CAMPAIGN_SUCCESS',
                        campaigns,
                    });
                    return resolve();
                }, !closed ? 300 : 0);
            }).then((res) => Promise.resolve(true));
        }
    }, ({ result }) => {
        dispatch({
            type: ' ARCHIVE_CAMPAIGN_FAILURE',
            message: result.errors[0].message,
        });
        return new Promise((resolve) => {
            setTimeout(() => {
                dispatch({
                    type: 'OPEN_OVERVIEW_MODAL',
                });
                return resolve();
            }, !closed ? 300 : 0);
            setTimeout(() => {
                dispatch({ type: 'DISMISS_FAILURE' });
            }, 4000);
        }).then((res) => Promise.resolve(false));
    });
};
exports.archiveListViewCampaign = (id) => (dispatch, getState) => {
    const query = graphql_tag_1.default `
            mutation CampaignArchive($id: ID!) {
                campaignArchive(id: $id)
            }
        `;
    const request = {
        query,
        variables: {
            id,
        },
    };
    return Environment_1.default(request).then(({ errors }) => {
        if (errors) {
            return handleError_1.default('ARCHIVE_CAMPAIGN_FAILURE', dispatch, errors[0].message);
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [id]: Object.assign(Object.assign({}, getState().campaignConnection.campaigns[id]), { status: 'ARCHIVED' }) });
            return dispatch({
                type: 'ARCHIVE_CAMPAIGN_SUCCESS',
                campaigns,
            });
        }
    }, ({ result }) => handleError_1.default('ARCHIVE_CAMPAIGN_FAILURE', dispatch, result.errors[0].message));
};
exports.archiveModalOpen = (display) => (dispatch) => {
    if (display) {
        dispatch({
            type: 'ARCHIVE_MODAL_OPEN',
            display,
        });
    }
    else {
        dispatch({
            type: 'ARCHIVE_MODAL_CLOSE',
            display,
        });
    }
};
exports.updateTags = (id, tags) => (dispatch, getState) => {
    dispatch({ type: 'UPDATE_TAGS_REQUEST' });
    const query = graphql_tag_1.default `
            mutation CampaignUpdateTags($id: ID!, $tags: [String!]!) {
                campaignUpdateTags(id: $id, tags: $tags)
            }
        `;
    const request = {
        query,
        variables: {
            id,
            tags,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('UPDATE_TAGS_FAILURE', dispatch, errors[0].message);
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [id]: Object.assign(Object.assign({}, getState().campaignConnection.campaigns[id]), { tags }) });
            return dispatch({
                type: 'UPDATE_TAGS_SUCCESS',
                campaigns,
            });
        }
    }, ({ result }) => handleError_1.default('UPDATE_TAGS_FAILURE', dispatch, result.errors[0].message));
};
exports.renameCampaign = (name, id) => (dispatch, getState) => {
    const query = graphql_tag_1.default `
            mutation CampaignRename($name: String!, $id: ID!) {
                campaignRename(name: $name, id: $id)
            }
        `;
    const request = {
        query,
        variables: {
            name,
            id,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('RENAME_CAMPAIGN_FAILURE', dispatch, errors[0].message);
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [id]: Object.assign(Object.assign({}, getState().campaignConnection.campaigns[id]), { name }) });
            return dispatch({
                type: 'RENAME_CAMPAIGN_SUCCESS',
                campaigns,
            });
        }
    }, ({ result }) => handleError_1.default('RENAME_CAMPAIGN_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchCampaigns = (searchChange, campaignStatus, keyword, first, after, triggerTypes) => (dispatch, getState) => {
    dispatch({ type: 'FETCH_CAMPAIGNS_REQUEST' });
    const baseQuery = graphql_tag_1.default `
        query FetchCampaigns(
            $first: Int!
            $keyword: String
            $orderBy: CampaignOrder
            $statuses: [CampaignStatus!]
            $triggerTypes: [CampaignTriggerType!] 
        ) {
            campaigns(
                first: $first
                keyword: $keyword
                orderBy: $orderBy
                statuses: $statuses
                triggerTypes: $triggerTypes
            ) {
                nodes {
                    ${nodeQuery}
                }
                pageInfo {
                    endCursor
                    hasNextPage                    
                } 
            }
        }
    `;
    const pagedQuery = graphql_tag_1.default `
        query FetchCampaigns(
            $after: String
            $first: Int!
            $keyword: String
            $orderBy: CampaignOrder
            $statuses: [CampaignStatus!]
            $triggerTypes: [CampaignTriggerType!] 
        ) {
            campaigns(
                after: $after
                first: $first
                keyword: $keyword
                orderBy: $orderBy
                statuses: $statuses
                triggerTypes: $triggerTypes
            ) {
                nodes {
                    ${nodeQuery}
                }
                pageInfo {
                    endCursor
                    hasNextPage                    
                } 
            }
        }
    `;
    let request;
    if (typeof after === 'undefined') {
        request = {
            query: baseQuery,
            variables: {
                keyword: keyword || null,
                first: first || 50,
                orderBy: { field: 'CREATED_AT', direction: 'DESC' },
                triggerTypes: triggerTypes,
                statuses: campaignStatus === null ? ['DRAFT', 'PUBLISHED'] : [campaignStatus],
            },
        };
    }
    else {
        request = {
            query: pagedQuery,
            variables: {
                keyword: keyword || null,
                first: first || 50,
                after: after,
                orderBy: { field: 'CREATED_AT', direction: 'DESC' },
                triggerTypes: triggerTypes,
                statuses: campaignStatus === null ? ['DRAFT', 'PUBLISHED'] : [campaignStatus],
            },
        };
    }
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_CAMPAIGNS_FAILURE', dispatch, errors[0].message);
        }
        else {
            let campaigns = null;
            let endCursor = null;
            let hasNextPage = false;
            if (data.campaigns) {
                campaigns = data.campaigns.nodes.reduce((prev, next) => {
                    return Object.assign({ [next.id]: next }, prev);
                }, {});
                endCursor = data.campaigns.pageInfo.endCursor;
                hasNextPage = data.campaigns.pageInfo.hasNextPage;
            }
            const updatedCampaigns = searchChange
                ? Object.assign({}, campaigns) : Object.assign(Object.assign({}, getState().campaignConnection.campaigns), campaigns);
            return dispatch({
                type: 'FETCH_CAMPAIGNS_SUCCESS',
                campaignConnection: {
                    campaigns: updatedCampaigns,
                    pageInfo: {
                        endCursor: endCursor,
                        hasNextPage: hasNextPage,
                    },
                },
            });
        }
    }, ({ result }) => handleError_1.default('FETCH_CAMPAIGNS_FAILURE', dispatch, result.errors[0].message));
};
exports.createCampaign = (name, trigger) => (dispatch, getState) => {
    dispatch({ type: `CREATE_CAMPAIGN_REQUEST` });
    const query = graphql_tag_1.default `
        mutation CampaignCreate($name: String!,
        $trigger: CampaignTriggerInput!, $deliverable: CampaignDeliverableInput!) {
            campaignCreate(name: $name, trigger: $trigger, deliverable: $deliverable) {
                ${nodeQuery}
            }
        }
    `;
    const baseDeliverable = {
        notification: {
            body: '',
            alertOptions: {
                badgeNumber: false,
                notificationCenter: false,
                systemNotification: true,
            },
            tapBehavior: {
                type: 'DEFAULT',
            },
        },
    };
    let baseTrigger;
    switch (trigger.__typename) {
        case 'CampaignScheduledTrigger':
            baseTrigger = {
                scheduledTrigger: {
                    segment: {
                        compoundSegment: {
                            condition: 'ALL',
                            ids: [],
                        },
                    },
                },
            };
            break;
        case 'CampaignAutomatedTrigger':
            baseTrigger = {
                automatedTrigger: {
                    delay: '0s',
                    eventTrigger: {
                        eventName: '',
                        filters: [],
                    },
                    limits: [
                        {
                            count: 1,
                        },
                    ],
                    segment: {
                        compoundSegment: {
                            condition: 'ALL',
                            ids: [],
                        },
                    },
                },
            };
            break;
        case 'CampaignAPITrigger':
            baseTrigger = {
                apiTrigger: {},
            };
            break;
    }
    const request = {
        query: query,
        variables: {
            name: name,
            trigger: baseTrigger,
            deliverable: baseDeliverable,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            dispatch({ type: `CLOSE_NEW_CAMPAIGN_POPOVER` });
            return handleError_1.default('CREATE_CAMPAIGN_FAILURE', dispatch, errors[0].message);
        }
        else {
            const campaigns = Object.assign(Object.assign({}, getState().campaignConnection.campaigns), { [data.campaignCreate.id]: Object.assign({}, data.campaignCreate) });
            dispatch({
                type: 'CREATE_CAMPAIGN_SUCCESS',
                campaigns,
            });
            dispatch({ type: `CLOSE_NEW_CAMPAIGN_POPOVER` });
            return Promise.resolve(data.campaignCreate.id);
        }
    }, ({ result }) => {
        dispatch({ type: `CLOSE_NEW_CAMPAIGN_POPOVER` });
        return handleError_1.default('CREATE_CAMPAIGN_FAILURE', dispatch, result.errors[0].message);
    });
};
exports.fetchReportConnection = (campaignId, after, before, first, last) => (dispatch, getState) => {
    dispatch({ type: 'FETCH_REPORT_CONNECTION_REQUEST' });
    const query = graphql_tag_1.default `
            query FetchReportConnection($campaignID: ID!, $after: String, $before: String, $first: Int, $last: Int) {
                notificationDeliveredByDateReport(
                    campaignID: $campaignID
                    after: $after
                    before: $before
                    first: $first
                    last: $last
                ) {
                    edges {
                        node {
                            id
                            notificationCenter
                            push
                        }
                        cursor
                    }
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                }
                notificationOpenedByDateReport(
                    campaignID: $campaignID
                    after: $after
                    before: $before
                    first: $first
                    last: $last
                ) {
                    edges {
                        node {
                            id
                            notificationCenter
                            pushDirect
                            pushInfluenced
                        }
                        cursor
                    }
                }
            }
        `;
    const request = {
        query,
        variables: {
            after,
            before,
            campaignID: campaignId,
            first,
            last,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_REPORT_CONNECTION_FAILURE', dispatch, errors[0].message);
        }
        const { edges: openedEdges, } = data.notificationOpenedByDateReport;
        const { edges: deliveredEdges, pageInfo, } = data.notificationDeliveredByDateReport;
        const reports = openedEdges.reduce((prev, { cursor, node }) => (Object.assign(Object.assign({}, prev), { [cursor]: {
                opened: node,
                delivered: deliveredEdges.find((edge) => edge.cursor === cursor).node,
            } })), {});
        dispatch({
            type: 'FETCH_REPORT_CONNECTION_SUCCESS',
            reportConnection: {
                reports,
                pageInfo,
            },
        });
    }, ({ result }) => handleError_1.default('FETCH_REPORT_CONNECTION_FAILURE', dispatch, result.errors[0].message));
};
exports.clearReportConnection = () => (dispatch) => {
    dispatch({
        type: 'CLEAR_REPORT_CONNECTION',
        reportConnection: {
            pageInfo: {},
            reports: {},
        },
    });
};
const updateCampaignUIState = () => (dispatch, getState) => {
    const query = graphql_tag_1.default `
            mutation CampaignUpdateUIState($id: ID!, $uiState: String!) {
                campaignUpdateUIState(id: $id, uiState: $uiState)
            }
        `;
    const { editableUIState, editableCampaign } = getState();
    const request = {
        query: query,
        variables: {
            id: editableCampaign.id,
            uiState: JSON.stringify(editableUIState),
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('UPDATE_UISTATE_FAILURE', dispatch, errors[0].message);
        }
        if (!data.campaignUpdateUIState) {
            return handleError_1.default('UPDATE_UISTATE_FAILURE', dispatch, 'Unexpected Error');
        }
    }, ({ result }) => handleError_1.default('UPDATE_UISTATE_FAILURE', dispatch, result.errors[0].message));
};
const getPredicatesStr = (numTimes) => {
    const str = `... on CompoundPredicate { booleanOperator predicates } ... on ComparisonPredicate {keyPath value { numberValue numberValues stringValue stringValues booleanValue booleanValues dateTimeValue dateTimeValues listValue { id name size createdAt } } modifier operator }`;
    const createStr = (numTimes, predicateStr) => {
        const regex = new RegExp('predicates(?!.*predicates)');
        if (numTimes === 0) {
            return predicateStr.replace(regex, '');
        }
        return createStr(numTimes - 1, predicateStr.replace(regex, `predicates {${str}}`));
    };
    return createStr(numTimes, str);
};
const segmentToOutput = (segment) => {
    if (!segment) {
        return null;
    }
    switch (segment.__typename) {
        case 'CompoundSegment':
            const { __typename: csName } = segment, restCompoundSegment = __rest(segment, ["__typename"]);
            return { compoundSegment: restCompoundSegment };
        case 'DeviceListSegment':
            const { deviceList: { id }, keyPath, } = segment;
            return { deviceListSegment: { id, keyPath } };
        case 'DevicePredicateSegment':
            const { predicate } = segment;
            return { devicePredicateSegment: { predicate: predicate ? util_1.predicateToInput(predicate) : undefined } };
        default:
            return null;
    }
};
const automatedFiltersToOutput = (filters) => {
    return filters.map((filter) => {
        switch (filter.__typename) {
            case 'DayOfTheWeekEventTriggerFilter': {
                const { __typename } = filter, rest = __rest(filter, ["__typename"]);
                return {
                    dayOfTheWeekEventTriggerFilter: rest,
                };
            }
            case 'EventAttributesEventTriggerFilter': {
                const { __typename } = filter, rest = __rest(filter, ["__typename"]);
                return {
                    eventAttributesEventTriggerFilter: {
                        predicate: util_1.predicateToInput(rest.predicate),
                    },
                };
            }
            case 'ScheduledEventTriggerFilter': {
                const { __typename } = filter, rest = __rest(filter, ["__typename"]);
                return {
                    scheduledEventTriggerFilter: rest,
                };
            }
            case 'TimeOfDayEventTriggerFilter': {
                const { __typename } = filter, rest = __rest(filter, ["__typename"]);
                return {
                    timeOfDayEventTriggerFilter: rest,
                };
            }
        }
    });
};
const nodeQuery = `
        id
        name
        trigger {
          ... on CampaignAPITrigger {
            __typename
            fields
            segment {
                ... on CompoundSegment {
                    __typename
                    ids
                    condition
                }
                ... on DevicePredicateSegment {
                    __typename
                    predicate {
                        ${getPredicatesStr(3)}
                      }
                }
            }
          }
          ... on CampaignAutomatedTrigger {
            __typename
            delay
            limits {
                count
                interval
            }
            eventTrigger {
              eventName
              eventNamespace
              filters {
                ... on DayOfTheWeekEventTriggerFilter {
                  __typename
                  monday
                  tuesday
                  wednesday
                  thursday
                  friday
                  saturday
                  sunday
                }
                ... on ScheduledEventTriggerFilter {
                  __typename
                  startDateTime {
                    date
                    time
                    timeZone
                  }
                  endDateTime {
                    date
                    time
                    timeZone
                  }
                }
                ... on TimeOfDayEventTriggerFilter {
                  __typename
                  startTime
                  endTime
                }
                ... on EventAttributesEventTriggerFilter {
                  __typename
                  predicate {
                    ${getPredicatesStr(3)}
                  }
                }
              }
            }
            segment {
                ... on CompoundSegment {
                    __typename
                    ids
                    condition
                }
                ... on DevicePredicateSegment {
                    __typename
                    predicate {
                        ${getPredicatesStr(3)}
                      }
                }
                ... on DeviceListSegment {
                    __typename
                    deviceList {
                        id
                        name
                        size
                        createdAt
                    }
                    keyPath
                }
            }
          }
          ... on CampaignScheduledTrigger {
            __typename
            dateTime {
              date
              time
              timeZone
            }
            segment {
                ... on CompoundSegment {
                    __typename
                    ids
                    condition
                }
                ... on DevicePredicateSegment {
                    __typename
                    predicate {
                        ${getPredicatesStr(3)}
                      }
                }
                ... on DeviceListSegment {
                    __typename
                    deviceList {
                        id
                        name
                        size
                        createdAt
                    }
                    keyPath
                }
            }
          }
        }
        deliverable {
          ... on CampaignNotificationDeliverable {
            __typename
            body
            title
            alertOptions {
              badgeNumber
              notificationCenter
              systemNotification
            }
            attachment {
              type
              url
            }
            tapBehavior {
              type
              url
              experienceID
              screenID
            }
            iOSOptions {
              categoryIdentifier
              contentAvailable
              mutableContent
              sound
              threadIdentifier
            }
            androidOptions {
              channelID
              tag
            }
          }
        }
        stats{
          totalDelivered
          uniqueOpened
        }
        status
        UIState: uiState
        createdAt
        updatedAt
        tags
`;
